module.exports = __webpack_public_path__ + "assets/images/seatingarrangement-01.bf34a11bd968db4fdca7cf3fe1805a86.svg";